import {flat, isLocatedPluralize, metCriteriaPluralize} from "@pg-mono/string-utils";
import {Country, OfferType} from "@pg-rp/common-types";

import {OFFER_GENERATED_DESCRIPTION_FLAT_CONTENT} from "../../constants/offer_generated_description_flat_content";
import {IOffer} from "../../types/property/IOffer";
import {OfferGeneratedDescriptionParkingPlaces} from "./OfferGeneratedDescriptionParkingPlaces";
import {OfferGeneratedDescriptionRoomRanges} from "./OfferGeneratedDescriptionRoomRanges";
import {OfferGeneratedDescriptionStorage} from "./OfferGeneratedDescriptionStorage";
import {OfferGeneratedDescriptionTextFlats} from "./OfferGeneratedDescriptionTextFlats";

interface IProps {
    country: Country;
    offer: IOffer;
    type: OfferType;
}

export const OfferGeneratedDescriptionFlat = (props: IProps) => {
    const {country, offer, type} = props;
    const {AVAILABLE_FLATS_HEADER, getMdmParagraph} = OFFER_GENERATED_DESCRIPTION_FLAT_CONTENT;

    const mdmCount = offer.stats?.properties_count_mdm;

    const mdmParagraph = mdmCount
        ? getMdmParagraph({
              areVerb: isLocatedPluralize(mdmCount),
              flatsLabel: flat.nominative(mdmCount),
              mdmCount,
              metVerb: metCriteriaPluralize(mdmCount),
              offerName: offer.name
          })
        : null;

    return (
        <>
            <OfferGeneratedDescriptionTextFlats country={country} offer={offer} />

            <OfferGeneratedDescriptionRoomRanges country={country} header={AVAILABLE_FLATS_HEADER} rooms_ranges={offer.stats?.rooms_ranges ?? []} type={type} />

            {mdmParagraph && <p>{mdmParagraph}</p>}

            <OfferGeneratedDescriptionParkingPlaces
                country={country}
                investor={offer.investor}
                offerName={offer.name}
                parking_places={offer.parking_places}
                vendor={offer.vendor}
            />

            <OfferGeneratedDescriptionStorage storage={offer.storage} />
        </>
    );
};
import {flat, isLocatedPluralize, metCriteriaPluralize} from "@pg-mono/string-utils";
import {Country, OfferType} from "@pg-rp/common-types";

import {OFFER_GENERATED_DESCRIPTION_FLAT_CONTENT} from "../../constants/offer_generated_description_flat_content";
import {IOffer} from "../../types/property/IOffer";
import {OfferGeneratedDescriptionParkingPlaces} from "./OfferGeneratedDescriptionParkingPlaces";
import {OfferGeneratedDescriptionRoomRanges} from "./OfferGeneratedDescriptionRoomRanges";
import {OfferGeneratedDescriptionStorage} from "./OfferGeneratedDescriptionStorage";
import {OfferGeneratedDescriptionTextFlats} from "./OfferGeneratedDescriptionTextFlats";

interface IProps {
    country: Country;
    offer: IOffer;
    type: OfferType;
}

export const OfferGeneratedDescriptionFlat = (props: IProps) => {
    const {country, offer, type} = props;
    const {AVAILABLE_FLATS_HEADER, getMdmParagraph} = OFFER_GENERATED_DESCRIPTION_FLAT_CONTENT;

    const mdmCount = offer.stats?.properties_count_mdm;

    const mdmParagraph = mdmCount
        ? getMdmParagraph({
              areVerb: isLocatedPluralize(mdmCount),
              flatsLabel: flat.nominative(mdmCount),
              mdmCount,
              metVerb: metCriteriaPluralize(mdmCount),
              offerName: offer.name
          })
        : null;

    return (
        <>
            <OfferGeneratedDescriptionTextFlats country={country} offer={offer} />

            <OfferGeneratedDescriptionRoomRanges country={country} header={AVAILABLE_FLATS_HEADER} rooms_ranges={offer.stats?.rooms_ranges ?? []} type={type} />

            {mdmParagraph && <p>{mdmParagraph}</p>}

            <OfferGeneratedDescriptionParkingPlaces
                country={country}
                investor={offer.investor}
                offerName={offer.name}
                parking_places={offer.parking_places}
                vendor={offer.vendor}
            />

            <OfferGeneratedDescriptionStorage storage={offer.storage} />
        </>
    );
};
